var MTIProjectId = '97d6c4bd-1291-42c0-a6fd-fb956cf786bc';
(function () {
    var mtiTracking = document.createElement('script');
    mtiTracking.type = 'text/javascript';
    mtiTracking.async = 'true';
    mtiTracking.src = FJ_DATA.stylesheet_uri + '/dist/vendor/mtiFontTrackingCode.js';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mtiTracking);
})();
